// extracted by mini-css-extract-plugin
module.exports = {"container":"DishCard_container__1TyG_","container_img":"DishCard_container_img__33F0X","header":"DishCard_header__32FpL","btn":"DishCard_btn__2MfrA"};